/*=========================================================================================
  File Name: moduleChatMutations.js
  Description: Chat Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'

export default {
  UPDATE_Items(state, data) {
    let t = JSON.parse(JSON.stringify(state['items']))
    t[data.name] = data.items.sort((a, b) => { return b.userType * 100 - a.userType * 100 + a.merchantType - b.merchantType }).map((x) => {
      return {
        label: x.shopName,
        value: x.accountId,
        isMerchant: x.userType && true || false,
        website:x.website,
        merchantType:x.merchantType
      };
    });
    state['items'] = t;
  },
  UPDATE_Default(state, data) {
    state['default'] = data;
  },
  UPDATE_Balance(state, data) {
    state['myBalance'] = parseInt(data.creditBalance + data.debitBalance
    ).toLocaleString();
  },
}

